<div class="pagebaground">
  <div class="wrap">
    <div class="logo">
      <h1><a [routerLink]="['/mainTabs/tabs/home']"><img src="assets/images/logo.png" /></a></h1>
      <img src="assets/images/signal.png" class="image" /><span>{{'page-not-found-page.page' | translate }}</span>
    </div>
    <div class="button-div">
      <button type="submit" class="Rectangle-2" [routerLink]="['/mainTabs/tabs/home']"><span
          class="button">{{'page-not-found-page.home' | translate }}</span></button>
    </div>
  </div>
</div>